export default {
  header: {
    products: '製品',
    events: 'イベント',
    exhibitor: '企業',
    societe: '会社',
    users: 'ユーザー',
    connector_admin: 'コネクター管理',
    company_settings: '会社設定',
    sign_out: 'ログアウト',
    categories: 'カテゴリ',
    subcategories: 'サブカテゴリ',
    universes: 'ユニバース',
  },
  eventList: {
    question: 'クイズ',
    exhibitor: '出展者',
    events: 'イベント情報',
    offers: 'オファー',
    forms: 'フォーム',
    offerEditor: 'オファーエディター',
    websiteEditor: 'ウェブサイトエディター',
    floorMap: 'フロアマップ',
    pdfEditor: 'PDFエディター',
    exhibitorsWebsite: '出展者ウェブサイト',
  },
};
